module.exports = __webpack_public_path__ + "static/media/matilde-hat-greece-sleepy.f69b8d00.png";